const locale = {
    placeholder: 'Vybrať čas',
};
export default locale;
